import axios from 'axios';
import store from '../store';

const APP_AUTH_ME = process.env.VUE_APP_AUTH_ME;
const APP_AUTH_TK = process.env.VUE_APP_AUTH_TK;

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        // if (error.message === "jwt expired"){
        //     router.push({ name: 'page.login' });
        // }
        reject(error);
    }
}

export default {
    apps() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/auth/modules/");
                resolve(data);
            } catch (error) {
                console.log(error);
                console.log('-- paksa login --, from Path: ', window.location.href);
                clearInterval(window.tokenRefreshInterval);
                window.localStorage.clear();
                window.location.reload();
                errorHandler(error, reject)
            }
        });
    },
    access(route) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`menus/access/${route}`);
                resolve(data);
            } catch (error) {
                console.log(error);
                errorHandler(error, reject);
            }
        });
    },
    current() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data: user } = await axios.get("users/me");
                resolve(user);
            } catch (error) {
                reject(error);
            };
        });
    },
    me() {
        const sdata = localStorage.getItem(APP_AUTH_ME);
        if (sdata) {
            const user = JSON.parse(sdata);
            // store.commit('user', user);
            // return user;
            if (user.username) {
                store.commit('user', user);
                return user;
            }

        }
        return null;
    },
    menus(group) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`menus/modul/${group}`);
                resolve(data);
            } catch (error) {
                // reject(error);
                errorHandler(error, reject);
            }
        });
    },
    menuroute(group) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`menus/menuroute/${group}`);
                resolve(data);
            } catch (error) {
                // reject(error);
                errorHandler(error, reject);
            }
        });
    },
    menuuser(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`menus/modul/${obj.modulname}/${obj.username}`);
                const list = data.reduce((newArr, item) => {
                    item.C = (item.permission && item.permission.indexOf('C') >= 0) ? 'C' : '';
                    item.R = (item.permission && item.permission.indexOf('R') >= 0) ? 'R' : '';
                    item.U = (item.permission && item.permission.indexOf('U') >= 0) ? 'U' : '';
                    item.D = (item.permission && item.permission.indexOf('D') >= 0) ? 'D' : '';
                    item.P = (item.permission && item.permission.indexOf('P') >= 0) ? 'P' : '';
                    item.O = (item.permission && item.permission.indexOf('O') >= 0) ? 'O' : '';
                    item.ALL = (item.permission && item.permission.indexOf('CRUDPO') >= 0);
                    newArr.push(item);
                    return newArr;
                }, []);
                const hasil = [];
                let _list1;
                let _list2;
                let _list3;
                const _list0 = list.filter(m => m.level === 0);
                for (let i = 0; i < _list0.length; i += 1) {
                    _list1 = list.filter(m => m.parent_id === _list0[i].name);
                    if (_list1.length > 0) {
                        _list0[i].display =
                            `<i style="position:absolute;margin-top:2px;" class="${_list0[i].icon}"></i>&nbsp;<strong style="margin-left:15px;">${_list0[i].title} </strong>`
                        _list0[i].cssClass = 'header';
                        hasil.push(_list0[i]);
                        for (let j = 0; j < _list1.length; j += 1) {
                            _list2 = list.filter(m => m.parent_id === _list1[j].name);
                            if (_list2.length > 0) {
                                _list1[j].display = `<strong style="margin-left:25px;">${_list1[j].title}</strong>`;
                                _list1[j].cssClass = 'header';
                                hasil.push(_list1[j]);
                                for (let k = 0; k < _list2.length; k++) {
                                    _list3 = list.filter(m => m.parent_id === _list2[k].name);
                                    if (_list3.length > 0) {
                                        _list2[k].display = `<strong style="margin-left:35px;">${_list2[k].title}</strong>`;
                                        _list2[k].cssClass = 'header';
                                        hasil.push(_list2[k]);

                                        for (var l = 0; l < _list3.length; l++) {
                                            _list3[l].display = `<em style="color:#000099;margin-left:45px;">${_list3[l].title}</em>`;
                                            _list3[l].cssClass = 'detail';
                                            hasil.push(_list3[l]);
                                        }
                                    } else {
                                        _list2[k].display = `<em style="color:#000099;margin-left:35px;">${_list2[k].title}</em>`;
                                        _list2[k].cssClass = 'detail';
                                        hasil.push(_list2[k]);
                                    }
                                }
                            } else {
                                _list1[j].display = `<em style="color:#000099;margin-left:25px;">${_list1[j].title}</em>`;
                                _list1[j].cssClass = 'detail';
                                hasil.push(_list1[j]);
                            }
                        }
                    } else {
                        _list0[i].display = `<em style="color:#000099;margin-left:25px;">${_list0[i].title}</em>`;
                        _list0[i].cssClass = 'detail';
                        hasil.push(_list0[i]);
                    }
                }
                resolve(hasil);
            } catch (error) {
                // reject(error);
                errorHandler(error, reject);
            }
        });
    },
    menusave(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("menus", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(token, user) {
        localStorage.setItem(APP_AUTH_TK, JSON.stringify(token));
        localStorage.setItem(APP_AUTH_ME, JSON.stringify(user));
        // const token1 = JSON.parse(localStorage.getItem(APP_AUTH_TK));
        // console.log('-- token save --', token1);
    },
    users(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'username', 'full_name', 'company'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const { data } = await axios.get(`users/list/${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                // reject(error);
                errorHandler(error, reject);
            }
        });
    },
    validate(user) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data: token } = await axios.post("auth/signin", user);
                axios.defaults.headers['Authorization'] = token.token;
                resolve(token);
            } catch (error) {
                // reject(error);
                errorHandler(error, reject);
            };
        });
    },
    validate_password(user) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data: token } = await axios.post("auth/validatepwd", user);
                resolve(token);
            } catch (error) {
                errorHandler(error, reject);
            };
        });
    },
    change_password(user) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data: token } = await axios.post("auth/changepwd", user);
                resolve(token);
            } catch (error) {
                errorHandler(error, reject);
            };
        });
    },
    reset_password(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/users/reset/${data.user_id}`, data)
                resolve(resp)
            } catch (error) {
                errorHandler(error, reject);
            };
        });
    },
    updateLastCompany(user) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put(`users/ulc/${user.user_id}`, { compcode: user.compcode });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            };
        });
    }
};